module.exports = __webpack_public_path__ + "static/Resin Bonded Bridges intraoral after-2ef2f76625702c953144240420cdefac.jpg";